<template>
    <div class="container-fluid" id="dvcrud">
        <div class="row">
            <div class="col-md-12">
                <breadcrumb v-bind:bcitens="itensbc" v-bind:mtdcancelar="mtdcancelaredicao"></breadcrumb>
            </div>
            <div class="col-md-12">
                <div id="pnlista" class="card" style="display: none;">
                    <div class="card-header"><span id="titlista">LISTAGEM DE {{ itensbc.item1.titulo }}</span>                        
                        <router-link to="/">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        </router-link>
                        <export-excel style="display: none;" id="btexportarexcel"
                            :data   = "lstfornecedores"
                            :fields = "json_fields"
                            name    = "fornecedores.xls">
                        </export-excel>                         
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" title="Exportar cadastros" style="margin-right: 10px;" @click.prevent="mtdexportarexcel()"><span aria-hidden="true"><i class="fa fa-upload"></i></span></button>                        
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" title="Importar cadastro de fornecedores" style="margin-right: 10px;" @click.prevent="mtdrotinaimportacao()"><span aria-hidden="true"><i class="fa fa-download"></i></span></button>                        
                    </div>
                    <div class="card-body" style="padding: 10px;">
                        <div class="row">
                            <div class="col-sm-4 col-md-2 col-lg-2">
                                <label for="cbopfiltro">Filtrar:</label>
                                <select name="cbopfiltro" class="form-control form-control-sm" id="cbopfiltro" v-model="pfiltro" @change="mtdlimpar_listagem()">
                                    <option value="0">Código</option>
                                    <option value="1">Nome/Razão Social</option>
                                </select>
                            </div>
                            <div class="col-sm-8 col-md-6 col-lg-6">
                                <label for="edconteudopesq">Conteúdo da pesquisa:</label>
                                <input id="edconteudopesq" type="text" class="form-control form-control-sm" v-model="pconteudo" @keyup="mtdlimpar_listagem()">
                            </div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbqtdreg">Registros:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cbqtdreg" v-model="pqtdregistros" @change="mtdlimpar_listagem()">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="99999999999">Todos</option>
                                </select>
                            </div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutapesquisa()"><i class="fa fa-search"></i> Listar</button>
                            </div>
                            <div class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table
                                        :rows="lstfornecedores"
                                        :columns="columns"
                                        :config="config"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->                                    
                                    <template slot="id_f" slot-scope="item">
                                        {{ item.row.id }}
                                    </template>
                                    <template slot="cnpjcpf_f" slot-scope="item">
                                        {{ formatacpfcnpj(item.row.cpfcnpj) }}
                                    </template>
                                    <template slot="opcoes" slot-scope="item">
                                        <button type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn" @click.prevent="mtdalterar(item.row)"><i class="fa fa-edit"></i></button>
                                        <button type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn" @click.prevent="mtdexcluir(item.row)"><i class="fa fa-trash"></i></button>
                                    </template>
                                </vue-bootstrap4-table>
                            </div>
                            <div class="col-md-12">
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                        Registros
                                        <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info">{{lstfornecedores.length}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer" style="padding: 10px;">
                        <div class="row">
                            <div class="col-8 col-sm-8 col-md-10 col-lg-10" id="dvpaginacao">
                                <v-pagination
                                        v-model="pagina_atual"
                                        :page-count="pqtd_paginas"
                                        :classes="bootstrapPaginationClasses">
                                </v-pagination>
                            </div>
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-success btn-sm btn-block" @click.prevent="mtdnovo()"><i class="fa fa-file"></i> Novo</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="pncadastro" class="card" style="display:none;">
                    <div class="card-header"><span>{{itensbc.item2.titulo}}</span>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="container-fluid">
                        <div class="row" style="margin-top: 10px;">
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                    <label for="cbtipo">Tipo:</label>
                                    <select class="form-control form-control-sm" id="cbtipo" v-model="vtipo"
                                            v-bind:disabled="ativadesativa1">
                                            <option value="0">Pessoa Física</option>
                                            <option value="1">Pessoa Jurídica</option>
                                            <option value="2">Extrangeiro</option>
                                    </select>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="cbtipocontribuinte">Tipo de Contribuinte:</label>
                                <select class="form-control form-control-sm" id="cbtipocontribuinte" v-model="vtipocontribuinte"
                                        v-bind:disabled="ativadesativa">
                                    <option value="1">Contribuinte ICMS</option>
                                    <option value="2">Contribuinte ISENTO</option>
                                    <option value="9">Não Contribuinte</option>
                                </select>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2">
                                <span class="lblselect2">Categoria:</span>
                                <select id="cbcategoria" data-placeholder="Selecione uma categoria" v-model="vidcategoria" v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>                                                        
                        </div>
                    </div>
                    <div class="card-body" v-show="parseInt(vtipo) == 0 || parseInt(vtipo) == 2">
                        <div class="row">
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edidfisico">Código:</label>
                                <input type="text" class="form-control form-control-sm" id="edidfisico" v-model="vid"
                                    maxlength="20" disabled/>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <label for="ednome">*Nome Completo:</label>
                                <input type="text" v-model="vnomerazaosocial" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="ednome" maxlength="50">
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="edcpf">*CPF:</label>
                                <input type="text" v-model="vcpfcnpj" v-bind:disabled="ativadesativa1"
                                    class="form-control form-control-sm" id="edcpf" maxlength="20">                                   
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="edrg">RG:</label>
                                <input type="text" v-model="vrgie" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edrg" maxlength="20"
                                    v-mask="'#######################'">
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="edfone1f">*Telefone 1:</label>
                                <input type="text" v-model="vfone1" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edfone1f" maxlength="20"
                                    v-mask="'(##)#####-####'">
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="edfone2f">Telefone 2:</label>
                                <input type="text" v-model="vfone2" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edfone2f" maxlength="20"
                                    v-mask="'(##)#####-####'">
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="edemailfcad">*E-mail:</label>
                                <input type="email" v-model="vemail" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edemailfcad" maxlength="100">
                            </div>

                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="edsitef">Site:</label>
                                <input type="text" v-model="vsite" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edsitef" maxlength="50">
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="eddtnascimento">*Data de Nascimento:</label>
                                <date-picker id="eddtnascimento" v-model="vdtnascimentofundacao" :config="options" class="form-control form-control-sm" v-bind:disabled="ativadesativa"></date-picker>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                            <label for="cbativo">*Ativo:</label>
                            <select class="form-control form-control-sm" id="cbativo" v-model="vativo"
                                    v-bind:disabled="ativadesativa">
                                    <option value="0">Sim</option>
                                    <option value="1">Não</option>
                            </select>
                            </div>
                        </div>
                    </div>
                    <div class="card-body" v-show="parseInt(vtipo) == 1">
                        <div class="row">
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edidjuridico">Código:</label>
                                <input type="text" class="form-control form-control-sm" id="edidjuridico" v-model="vid"
                                    maxlength="20" disabled/>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <label for="edrazaosocial">*Razão Social:</label>
                                <input type="text" v-model="vnomerazaosocial" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edrazaosocial" maxlength="50">
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="edcnpjfornecedor">*CNPJ:</label>
                                <input type="text" v-model="vcpfcnpj" v-bind:disabled="ativadesativa1"
                                    class="form-control form-control-sm" id="edcnpjfornecedor" maxlength="20">
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="edfantasia">Fantasia:</label>
                                <input type="text" v-model="vfantasia" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edfantasia" maxlength="50">
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="edie">Inscrição Estadual:</label>
                                <input type="text" v-model="vrgie" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edie" maxlength="20"
                                    v-mask="'#######################'">
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="edfone1j">*Telefone 1:</label>
                                <input type="text" v-model="vfone1" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edfone1j" maxlength="20"
                                    v-mask="'(##)#####-####'">
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="edfone2j">Telefone 2:</label>
                                <input type="text" v-model="vfone2" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edfone2j" maxlength="20"
                                    v-mask="'(##)#####-####'">
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="edemailj">*E-mail:</label>
                                <input type="email" v-model="vemail" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edemailj" maxlength="100">
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="edsitej">Site:</label>
                                <input type="text" v-model="vsite" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edsitej" maxlength="50">
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="edcontato">Contato:</label>
                                <input type="text" v-model="vcontato" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edcontato" maxlength="50">
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="edinscricaosuframa">Insc. Suframa:</label>
                                <input type="text" v-model="vinscricaosuframa" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edinscricaosuframa" maxlength="20"
                                    v-mask="'#########################'">
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="eddtfundacao">*Data de Fundação:</label>
                                <date-picker id="eddtfundacao" v-model="vdtnascimentofundacao" :config="options" class="form-control form-control-sm" v-bind:disabled="ativadesativa"></date-picker>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                            <label for="cbativo">*Ativo:</label>
                            <select class="form-control form-control-sm" id="cbativo" v-model="vativo"
                                    v-bind:disabled="ativadesativa">
                                    <option value="0">Sim</option>
                                    <option value="1">Não</option>
                            </select>
                            </div>                      
                        </div>
                    </div>
                    <div class="col-md-12" style="margin-top: 15px; margin-botton: 15px; border: 10px;">
                            <ul class="nav nav-tabs">
                                <li class="nav-item">
                                    <a class="nav-link active" data-toggle="tab" href="#dvendereco">Endereço</a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link" data-toggle="tab" href="#dvobservacoes">Observações</a>
                                </li>
                            </ul>
                            <div class="tab-content border-left border-right border-bottom" style="padding-top: 15px; padding-bottom: 15px;">
                                <div class="tab-pane container-fluid active" id="dvendereco">
                                    <div class="row">
                                        <div class="col-sm-12 col-md-2 col-lg-2">
                                            <label for="edcep">*CEP:</label>
                                            <input type="text" v-mask="'#####-###'" class="form-control form-control-sm"
                                                   id="edcep" v-model="vcep" v-bind:disabled="ativadesativa"
                                                   data-bv-group=".group" maxlength="10">
                                        </div>
                                        <div class="col-sm-12 col-md-4 col-lg-4">
                                            <label for="edlogradouro">*Logradouro:</label>
                                            <input type="text" class="form-control form-control-sm" id="edlogradouro"
                                                   v-model="vlogradouro" v-bind:disabled="ativadesativa"
                                                   data-bv-group=".group" maxlength="100">
                                        </div>
                                        <div class="col-sm-12 col-md-2 col-lg-2">
                                            <label for="ednumeroendereco">*Número:</label>
                                            <input type="text" class="form-control form-control-sm" id="ednumeroendereco"
                                                   v-model="vnumeroendereco" v-bind:disabled="ativadesativa"
                                                   data-bv-group=".group" maxlength="20">
                                        </div>
                                        <div class="col-sm-12 col-md-4 col-lg-4">
                                            <label for="edreferencia">Referência:</label>
                                            <input type="text" class="form-control form-control-sm" id="edreferencia"
                                                   v-model="vreferencia" v-bind:disabled="ativadesativa"
                                                   data-bv-group=".group" maxlength="100">
                                        </div>

                                        <div class="col-sm-12 col-md-6 col-lg-6">
                                            <span class="lblselect2">*Bairro:</span>
                                            <select id="cbbairro" v-model="vidbairro" v-bind:disabled="ativadesativa"
                                                    data-placeholder="Selecione uma opção" data-allow-clear="true"
                                                    style="width:100%;">
                                            </select>
                                        </div>
                                        <div class="col-sm-12 col-md-4 col-lg-4">
                                            <span class="lblselect2">*Município:</span>
                                            <select id="cbmunicipio" v-model="vidmunicipio"
                                                    v-bind:disabled="ativadesativa"
                                                    data-placeholder="Selecione uma opção" data-allow-clear="true"
                                                    style="width:100%;">
                                            </select>
                                        </div>
                                        <div class="col-sm-12 col-md-2 col-lg-2">
                                            <span class="lblselect2">*UF:</span>
                                            <select id="cbuf" v-model="viduf" v-bind:disabled="ativadesativa"
                                                    data-placeholder="Selecione a UF" data-allow-clear="true"
                                                    style="width:100%;">
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="tab-pane container-fluid" id="dvobservacoes">
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <textarea class="form-control center" rows="6" id="txtobs" v-model="vobs" v-bind:disabled="ativadesativa"></textarea>
                                        </div>									
                                    </div>
                                </div>
                            </div>
						</div>
                        <div class="card-footer" style="margin-top: 20px;">
                        <div class="row">
                            <div class="col-sm-8">
                                <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;"><strong>Campos com asterisco(*) devem ser informados</strong>.</h5>
                            </div>
                            <div class="col-sm-2">
                                <button id="btgravar" v-if="(opcrud == 1)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Gravar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 2)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Alterar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 3)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Excluir
                                </button>
                            </div>
                            <div class="col-sm-2">
                                <button type="button" @click.prevent="mtdcancelaredicao()" class="btn btn-secondary btn-sm" style="width:100%">
                                    <i class="fa fa-close"></i> Cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="pnimportacao" class="card" style="display: none;">
                    <div class="card-header"><span id="titlista">IMPORTAÇÃO DE CADASTRO DE FORNECEDORES</span>                        
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body" style="padding: 30px;">
                        <div class="row">
                                <div class="col-md-12" style="padding-bottom: 15px!important;">
                                    <h1 style="color: #0acf97!important;" class="text-info">Importação de cadastro</h1>
                                </div>
                                <div class="col-md-12">
                                    <p style="text-indent: 1.5em; font-size: 14px; color: #666;">
                                        Para este procedimento uma matriz de arquivo no formato do EXCEL(.xls) está disponibilizada para download. Basta clicar no link a baixo para baixá-la.
                                        Preencha a mesma com os dados corretamente, sem alterar as posições das colunas.
                                        Após o preenchimento, salve os dados e clique em "Enviar arquivo". Aguarde o processamento, ao final o sistema irá listar o resultado da importação.</p>
                                    <p style="font-size: 14px; color: #666; margin-left: 50px;">
                                        Campos de CNPJ, telefone, CEP, devem ser informados somente os números, sem formatação;<br>
                                        Campo de Data deve ser informados no formato dd/mm/aaaa, sendo que os mesmos devem estar formatados como texto no EXCEL (utilize a fórmula <strong>=TEXTO(A1; "dd/mm/aaaa")</strong>, em seguida copiar e colar especial).<br>
                                    </p>
                                </div>
                                <div class="col-sm-12 col-md-12 col-lg-12">
                                    <div class="custom-control custom-checkbox chbajuste">
                                        <input type="checkbox" class="custom-control-input" id="cblimpardados" v-model="vlimpardados">
                                        <label class="custom-control-label" for="cblimpardados" style="color: #f82b54;">Limpar cadastro existente</label>
                                    </div>
                                </div>
                                <div class="col-md-8">
                                    <input type="file" id="btselecionararqenviar" accept=".xls" style="display: none;">
                                </div>
                                <div class="col-md-2">
                                    <button type="button" class="btn btn-green" @click.prevent="mtdbaixarmatriz()" style="width: 100%; margin-bottom: 10px; min-height: 75px; margin-top: 10px;">
                                        <img src="@/assets/matrizexcel.png">
                                        Baixar matriz
                                    </button>
                                </div>
                                <div class="col-md-2">
                                    <input
                                        type="file" 
                                        id="ipselecionararquivo"
                                        accept=".xls" 
                                        @change="mtdselecionararquivo" 
                                        style="display: none;"
                                        ref="if_selecionarquivo">                                    
                                    <button type="button" @click="$refs.if_selecionarquivo.click()" class="btn btn-blue" style="width: 100%; margin-bottom: 10px; min-height: 75px; margin-top: 10px;"><i class="fa fa-upload"></i>
                                        Enviar arquivo
                                    </button>
                                </div>
                        </div>
                    </div>
                    <div class="card-footer" style="padding: 10px;">
                        <div class="row">
                            <div class="col-8 col-sm-8 col-md-10 col-lg-10">
                            </div>
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-secondary btn-sm btn-block" @click.prevent="mtdcancelaredicao()"><i class="fa fa-close"></i> Cancelar</button>
                            </div>
                        </div>
                    </div>                                        
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import BreadCrumb from '../components/cmpbreadcrumb.vue'
    import VueBootstrap4Table from 'vue-bootstrap4-table'
    import vPagination from 'vue-plain-pagination'
    import Swal from "sweetalert2/dist/sweetalert2.js"
    import "sweetalert2/dist/sweetalert2.min.css"
    import util from '../utilitarios/util.js'

    export default {
        name: 'cadfornecedores',
        components:{
            VueBootstrap4Table,
            vPagination,
            'breadcrumb' : BreadCrumb
        },
        data: function() {
            return {
                lstfornecedores  : [],
                pfiltro      : 1,
                pconteudo    : '',
                pqtdregistros: 10,
                pqtd_paginas : 1,
                pagina_atual : 1,
                pqtd_total_registros: 0,

                //variáveis do crud
                opcrud                  :  0,
                vid                     : '',
                vcpfcnpj                : '',
                vrgie                   : '',
                vnomerazaosocial        : '',
                vfone1                  : '',
                vfone2                  : '',
                vemail                  : '',
                vsite                   : '',
                vdtnascimentofundacao   : '',
                vcontato                : '',
                vinscricaosuframa       : '',
                vfantasia               : '',
                vlogradouro             : '',
                vnumeroendereco         : '',
                vidbairro               : '',
                vidmunicipio            : '',
                viduf                   : '',
                vreferencia             : '',
                vcep                    : '',
                vobs                    : '',
                vtipo                   :  1,
                vtipocontribuinte       :  9,
                vativo                  :  0,
                vidcategoria            : null,

                //variável da importação
                vlimpardados            : false,
                arqselecionado          : null,

                //variável para habilitação dos campos
                ativadesativa       : true,
                ativadesativa1      : true,
                

                //variáveis para exportação para o excel
                //caso queira exportar todo o conteúdo não informar o json_fields na declaração do componente
                json_fields: {
                            'Código'      : 'id',
                            'Nome'        : 'nomerazaosocial',
                            'Fantasia'    : 'fantasia',
                            'CPF/CNPJ'    : 'cpfcnpj',
                            'RG/IE'       : 'rgie',
                            'CEP'         : 'cep',
                            'Logradouro'  : 'logradouro',
                            'Nr.:'        : 'numeroendereco',
                            'Bairro'      : 'descricaobairro',
                            'Município'   : 'descricaomunicipio',
                            'UF'          : 'iduf',
                            'Complemento' : 'referencia',
                            'Fone'        : 'fone1',
                            'E-mail'      : 'email',
                            'site'        : 'site'
                },
                json_meta: [
                    [
                        {
                            'key': 'charset',
                            'value': 'utf-8'
                        }
                    ]
                ],                
                ///////////////////////////////
                                
                options: {
                    format      : 'DD/MM/YYYY',
                    useCurrent  : false,
                    locale      : 'pt-BR'                       
                },

                bootstrapPaginationClasses: {
                    ul: 'pagination pagination-sm',
                    li: 'page-item',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'
                },
                itensbc : {
                    item1 : {
                        titulo : 'FORNECEDORES',
                        ativo  : false
                    },
                    item2 : {
                        titulo : '',
                        ativo  : false
                    }
                },
                columns: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes",
                        sort: false
                    },
                    {
                        label: "Código",
                        name: "id",
                        sort: true,
                        initial_sort : false,
                        slot_name: "id_f",
                        row_classes: "def-col-cod",
                    },
                    {
                        label: "Nome/Razão social",
                        name: "nomerazaosocial",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "CPF/CNPJ",
                        name: "cpfcnpj",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        slot_name: "cnpjcpf_f",
                        row_classes: "def-col-cnpjcpf"
                    },
                    {
                        label: "Categoria",
                        name: "desccategoria",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    }
                ],
                config: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },
                classes: {
                    table: "table-bordered table-striped table-sm"
                }
            }
        },
        methods:{
            formatacpfcnpj(val) {
                return util.formatacpfcnpj(val);
            },
            mtdfiltropesquisa(){
                let rfiltro = '';
                if (parseInt(this.pfiltro) === 0){
                    rfiltro = this.pconteudo === '' ? '' : ' and f.id='+this.pconteudo;
                }else{
                    rfiltro = this.pconteudo === '' ? '' : ' and upper(f.nomerazaosocial) like upper(\''+this.pconteudo+'%\')';
                }
                return rfiltro;
            },
            mtdexecutapesquisa(){
                var vself           = this;
                let filtro          = vself.mtdfiltropesquisa();
                this.pagina_atual   = 1;
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'qtdregistros'},
                    {parametro: 'filtro',       valor  : filtro}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadfornecedores.php');
                retorno.then(function (response) {
                    vself.pqtd_total_registros = parseInt(response.data.qtdregistros);
                    let qtdpg                  = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
                    vself.pqtd_paginas         = qtdpg > 0 ? qtdpg : 1;
                    vself.mtdcarregafornecedores(1);
                }).catch(function (response) {
                    alert('Erro ao consultar registros');
                });
            },
            mtdcarregafornecedores(ipagina){
                var vself       = this;
                let loader      = this.$loading.show();
                let filtro      = vself.mtdfiltropesquisa();
                let parametros  = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : vself.pqtdregistros},
                    {parametro: 'offset',       valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistros)},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadfornecedores.php');
                retorno.then(function (response) {
                    vself.lstfornecedores = response.data;
                    loader.hide();
                }).catch(function (response) {
                    vself.lstfornecedores = [];
                    loader.hide();
                });
            },
            resetarDados() {
                util.toTop();

                this.vid                     = '';
                this.vcpfcnpj                = '';
                this.vrgie                   = '';
                this.vnomerazaosocial        = '';
                this.vfone1                  = '';
                this.vfone2                  = '';
                this.vemail                  = '';
                this.vsite                   = '';
                this.vdtnascimentofundacao   = '';
                this.vcontato                = '';
                this.vinscricaosuframa       = '';
                this.vfantasia               = '';
                this.vlogradouro             = '';
                this.vnumeroendereco         = '';
                this.vidbairro               = '';
                this.vidmunicipio            = '';
                this.viduf                   = '';
                this.vreferencia             = '';
                this.vcep                    = '';
                this.vobs                    = '';
                this.vtipo                   =  1;
                this.vtipocontribuinte       =  9;
                this.vativo                  =  0;
                this.vidcategoria            = null;

                $('#cbbairro').val(null).trigger('change');
                $('#cbmunicipio').val(null).trigger('change');
                $('#cbuf').val(null).trigger('change');
                $("#cbcategoria").val(null).trigger('change');                  
            },
            mtddefault(){
                $('#pnlista').hide();
                this.resetarDados();
                $('#pncadastro').fadeIn(700);
                this.$nextTick(function () {
                    if (parseInt(this.opcrud) === 1) {
                        $('#cbtipo').focus();
                    } else if (parseInt(this.opcrud) === 2){
                        setTimeout(function(){
                            $('#edrazaosocial').focus();
                        },200)                        
                    }else {
                        setTimeout(function(){
                            $('#btgravar').focus();
                        },200)                                                  
                    }
                });
            },
            mtdpreparacrud(op) {
                let vself    = this;
                vself.opcrud = op;
                $('.nav-tabs a[href="#dvperfil"]').tab('show');
                vself.mtddefault();
                
            },
            mtdnovo(){
                if (!util.opcaousuario('002Z.001M.001L', this.$store.state.perfilusuario)){
                    util.notif("warning", 'Acesso não permitido para o usuário!');
                }else {
                    this.itensbc.item2.titulo = 'INCLUSÃO DE FORNECEDORES';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.ativadesativa1 = false;
                    this.mtdpreparacrud(1);
                }
            },
            mtdcancelaredicao(){
                this.itensbc.item1.ativo = false;
                this.itensbc.item2.ativo = false;
                $('#pncadastro').hide();
                $('#pnimportacao').hide();
                $('#pnlista').fadeIn(700);
                $('#edconteudopesq').focus();
                setTimeout(function(){
                    util.toTop();
                }, 200);
            },
            mtdpesquisacep(){
                let vself = this;
                let cepinf = vself.vcep;
                if ( cepinf != ''){
                    if (util.IsCEP(cepinf, '')){
                        let loader = vself.$loading.show();
                        let parametros = [
                            {parametro: 'param1', 		valor: 'consultarcep'},
                            {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                            {parametro: 'cep', 			valor: cepinf}
                        ];
                        let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/buscarcep.php');
                        retorno.then(function (response) {
                            loader.hide();
                            if (response.data != '0') {
                                
                                vself.vlogradouro       = response.data.logradouro;
                                vself.vreferencia       = response.data.complemento;

                                var defmun = new Option(response.data.descmunicipio, response.data.idmunicipio, true, true);
                                $('#cbmunicipio').append(defmun).trigger('change');

                                var defbai = new Option(response.data.descbairro, response.data.idbairro, true, true);
                                $('#cbbairro').append(defbai).trigger('change');

                                var defuf = new Option(response.data.descuf, response.data.iduf, true, true);
                                $('#cbuf').append(defuf).trigger('change');
                            }else{
                                util.notif("warning", 'CEP inválido ou inexistente!');
                            }					

                        }).catch(function (response) {
                            loader.hide();
                            console.log(response.message);
                        });
                    }
                }                
            },
            mtdlimpar_listagem() {
                this.lstfornecedores = [];
                this.pagina_atual = 1;
                this.filtro = '';
                this.pqtd_total_registros = 0;
                this.pqtd_paginas = 0;
            },
            mtdgravar(){
                let vself = this;
                if (parseInt(vself.opcrud) < 3) {
                    if (parseInt(vself.vtodasfiliais) === 0) {
                    }
                }
                if (vself.vtipo == 0 && vself.opcrud == 1) {
                    if ((vself.vcpfcnpj.length < 11) || (util.validarCPF(vself.vcpfcnpj) == false)) {
                        util.notif("warning", "O CPF digitado é inválido!");
                        $("#edcpf").focus();
                         return;
                    }
                }
                if (vself.vtipo == 1 && vself.opcrud == 1) {
                    if ((vself.vcpfcnpj.length < 14) || (util.validarCNPJ(vself.vcpfcnpj) == false)) {
                        util.notif("warning", "O CNPJ digitado é inválido!");
                        $("#edcnpjfor").focus();
                        return;
                    }
                }
                Swal.fire({
                    customClass: {
                        confirmButton: "btn btn-success conf",
                        cancelButton: "btn btn-danger"
                    },
                    title: "Confirmação",
                    text: 'Confirma ' + vself.itensbc.item2.titulo + '?',
                    icon: "question",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Sim",
                    cancelButtonText: "Cancelar"
                }).then((result) => {
                    if (result.isConfirmed) {
                        $('.conf').prop('disabled', true);
                        vself.mtdregistro();
                    } else {
                        $('#btgravar').focus();
                    }
                });
            },
            mtdlocalizaregistro(id){
                var vself       = this;
                let loader      = vself.$loading.show();
                let filtro      = ' and f.id='+id;
                let parametros  = [
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : 1},
                    {parametro: 'offset',       valor : 0},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadfornecedores.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.mtdigualarcampos(response.data[0]);
                    if (parseInt(vself.opcrud) < 3){
                        $('#eddescricao').focus();
                    }else{
                        $('#btgravar').focus();
                    }
                }).catch(function (response) {
                    loader.hide();
                });
            },
            mtdalterar(item){
                if (!util.opcaousuario('002Z.001M.002L', this.$store.state.perfilusuario)){
                    util.notif("warning", 'Acesso não permitido para o usuário!');
                }else {
                    this.itensbc.item2.titulo = 'ALTERAÇÃO DE FORNECEDORES';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.ativadesativa1 = true;
                    this.mtdpreparacrud(2);
                    this.mtdlocalizaregistro(item.id);
                }
            },
            mtdexcluir(item){
                if (!util.opcaousuario('002Z.001M.003L', this.$store.state.perfilusuario)){
                    util.notif("warning", 'Acesso não permitido para o usuário!');
                }else {
                    this.itensbc.item2.titulo = 'EXCLUSÃO DE FORNECEDORES';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = true;
                    this.ativadesativa1 = true;
                    this.mtdpreparacrud(3);
                    this.mtdlocalizaregistro(item.id);
                }
            },
            mtdselect2_def(){
                let vself = this;
                $("#cbcategoria").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbcategorias',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }).change(function () {
                    vself.vidcategoria = $("#cbcategoria").val();
                });

                $("#cbbairro").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbbairros',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 2,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidbairro = $("#cbbairro").val();
                });
                $("#cbmunicipio").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbmunicipios',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 2,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidmunicipio = $("#cbmunicipio").val();
                });
                $("#cbuf").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbufs',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.viduf = $("#cbuf").val();
                });
                $("#edcep").blur(function(){
                    vself.mtdpesquisacep();
                });
            },
            mtdigualarcampos(registro){
                this.vid                     = registro.id;
                this.vcpfcnpj                = registro.cpfcnpj;
                this.vrgie                   = registro.rgie;
                this.vnomerazaosocial        = registro.nomerazaosocial;
                this.vfone1                  = registro.fone1;
                this.vfone2                  = registro.fone2;
                this.vemail                  = registro.email;
                this.vsite                   = registro.site;
                this.vdtnascimentofundacao   = registro.dtnascimentofundacao;
                this.vcontato                = registro.contato;
                this.vinscricaosuframa       = registro.inscricaosuframa;
                this.vfantasia               = registro.fantasia;
                this.vlogradouro             = registro.logradouro;
                this.vnumeroendereco         = registro.numeroendereco;
                this.vreferencia             = registro.referencia;
                this.vcep                    = registro.cep;
                this.vobs                    = registro.obs;
                this.vtipo                   = registro.tipo;
                this.vtipocontribuinte       = registro.tipocontribuinte;
                this.vativo                  = registro.ativo;
                this.vidbairro               = registro.idbairro;
                this.vidmunicipio            = registro.idmunicipio;
                this.viduf                   = registro.iduf;
                this.vidcategoria            = registro.idcategoria === 0 ? null : registro.idcategoria; 

                var defmunicipio = new Option(registro.descricaomunicipio, this.vidmunicipio, true, true);
                $('#cbmunicipio').append(defmunicipio).trigger('change');

                var defbairro = new Option(registro.descricaobairro, this.vidbairro, true, true);
                $('#cbbairro').append(defbairro).trigger('change');

                var defuf = new Option(registro.descricaouf, this.viduf, true, true);
                $('#cbuf').append(defuf).trigger('change');

                if (this.vidcategoria !== null){
                    var defcat                = new Option(registro.desccategoria, registro.idcategoria, true, true);
                    $('#cbcategoria').append(defcat).trigger('change');                
                }else{
                    $('#cbcategoria').val(null).trigger('change');
                }
            },
            mtdregistro(){
                let vself  = this;
                let loader = vself.$loading.show();
                let registrocrud = {
                    'id'                         : this.vid,
                    'cpfcnpj'                    : this.vcpfcnpj,
                    'idcategoria'                : this.vidcategoria === null ? 0 : this.vidcategoria, 
                    'rgie'                       : this.vrgie,
                    'nomerazaosocial'            : this.vnomerazaosocial,
                    'fone1'                      : this.vfone1,
                    'fone2'                      : this.vfone2,
                    'email'                      : this.vemail,
                    'site'                       : this.vsite,
                    'dtnascimentofundacao'       : this.vdtnascimentofundacao,
                    'contato'                    : this.vcontato,
                    'inscricaosuframa'           : this.vinscricaosuframa,
                    'fantasia'                   : this.vfantasia,
                    'logradouro'                 : this.vlogradouro,
                    'referencia'                 : this.vreferencia,
                    'cep'                        : this.vcep,
                    'obs'                        : this.vobs,
                    'tipo'                       : this.vtipo,
                    'tipocontribuinte'           : this.vtipocontribuinte,   
                    'ativo'                      : this.vativo,
                    'idbairro'                   : this.vidbairro,
                    'iduf'                       : this.viduf,
                    'idmunicipio'                : this.vidmunicipio,
                    'numeroendereco'             : this.vnumeroendereco
                };
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'rotinacrud'},
                    {parametro: 'opcrud',       valor : vself.opcrud},
                    {parametro: 'registro',     valor : JSON.stringify(registrocrud)},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : parseInt(this.opcrud) === 1 ? '002Z.001M.001L' : parseInt(this.opcrud) === 2 ? '002Z.001M.002L' : '002Z.001M.003L'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadfornecedores.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        util.notif("success", 'Registro processado com sucesso!')
                        vself.pfiltro       = 0;
                        vself.pconteudo     = parseInt(vself.opcrud) === 1 ? response.data : vself.vid;
                        vself.pqtd_paginas  = 1;
                        vself.mtdcancelaredicao();
                        vself.mtdcarregafornecedores(1);
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                util.notif("warning", response.data.substring(4))
                                break;
                            case 'E': default:
                                util.notif("error", response.data.substring(4))
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    util.notif("error", 'Erro ao processar o registo. Descrição do erro: ' + response.message);
                });
            },
            mtdrotinaimportacao(){
                if (!util.opcaousuario('002Z.001M.004L', this.$store.state.perfilusuario)){
                    util.notif("warning", 'Acesso não permitido para o usuário!');
                }else {
                    this.itensbc.item2.titulo = 'IMPORTAÇÃO DE CADASTRO DE FORNECEDORES';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    $('#pnlista').hide();
                    this.resetarDados();
                    this.arqselecionado = null;
                    this.vlimpardados   = false;
                    $('#pnimportacao').fadeIn(700);
                }                
            },
            mtdbaixarmatriz(){
                window.open('https://racosys.top/controller/arquivosimportacao/manager/matrizes/matrizimportarfornecedores.xls', '_blank');
            },
            mtdselecionararquivo(event){                
                let vself            = this;                 
                vself.arqselecionado = event.target.files[0];

                let extarq  = vself.arqselecionado.name.substring(vself.arqselecionado.name.lastIndexOf('.') + 1);
                if (extarq.toUpperCase() !== 'XLS'){
                    vself.arqselecionado = null;
                    util.notif("warning", 'O arquivo selecionado não possui um formato válido');
                    return;
                }

                let loader      = vself.$loading.show();
                let localsalvar = 'controller/arquivosimportacao/manager/'+
                                  vself.$store.state.filialpadrao.idcliente;

                let parametros      = [
                    {parametro: 'arquivo',          valor  : vself.arqselecionado},
                    {parametro: 'localsalvar',      valor  : localsalvar},
                    {parametro: 'nomearquivo',      valor  : vself.arqselecionado.name}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/uploadfile.php');
                retorno.then(function (response) {
                    if ($.isNumeric(response.data.inf)){
                        vself.mtdcancelaredicao();
                        vself.lstfornecedores= [];
                        vself.pqtd_paginas   = 0;                                                
                        let oplimpar         = vself.vlimpardados === false ? '0' : '1';
                        let url              = 'https://www.'+vself.$store.state.usuario.adrsrv+'/controller/importadores/manager/importarfornecedores.php?idclientesac='+vself.$store.state.filialpadrao.idcliente+
                                               '&arquivoimportar='+vself.arqselecionado.name+'&limparcadastro='+oplimpar+
                                               '&idfilial='+vself.$store.state.filialpadrao.codfil+'&idu='+
                                               vself.$store.state.usuario.id+'&codop=002Z.001M.004L';
                        vself.arqselecionado = null;                                               
                        window.open(url, '_blank');                        
                    }else{
                        vself.arqselecionado = null;
                        $('#ipselecionararquivo').val('');
                        util.notif("error", 'Erro ao processar o registo. Descrição do erro: ' + response.data);
                    }
                    loader.hide();
                }).catch(function (response) {
                    loader.hide();
                    util.notif("error", 'Erro ao processar o registo. Descrição do erro: ' + response.message);
                    vself.arqselecionado = null;
                    $('#ipselecionararquivo').val('');
                });                
            },
            mtdexportarexcel(){
                $('#btexportarexcel').click();
            }           
        },
        mounted: function () {
            if (util.verificasessao(this)) {
                let vself = this;
                let loader = vself.$loading.show();
                let parametros = [
                    {parametro: 'op', valor: 'dadosusuario'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.usuario.idclientesac},
                    {parametro: 'idusuario', valor: vself.$store.state.usuario.id}
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.$store.commit('MUDAR_PERFIL_USUARIO', response.data.perfilusu);
                    if (util.opcaousuario('002Z.001M', vself.$store.state.perfilusuario)) {
                        $('#pnlista').fadeIn(700);
                        vself.mtdexecutapesquisa();
                        vself.mtdselect2_def();
                    } else {
                        util.notif("warning", 'Acesso não permitido para o usuário!');
                        setTimeout(function(){
                            util.gotoprincipal();
                        },1000);
                    }
                }).catch(function (response) {
                    loader.hide();
                    console.log(response.message);
                });
            }
        },
        computed:{
            validou() {
                return this.vnomerazaosocial === '' || this.vcpfcnpj === '' || this.vfone1 === '' ||
                this.vdtnascimentofundacao === '' || this.vcep === '' || this.vlogradouro === '' || 
                this.vnumeroendereco === '' || this.vnumeroendereco === '' || this.viduf == null || 
                this.vidbairro == null || this.vidmunicipio == null;
            }
        },
        watch:{
            pagina_atual(val){
                this.mtdcarregafornecedores(val);
            }
        }
    }
</script>
<style>
    .def-col-cod{
        width: 80px !important;
    }
</style>